import React, { useEffect, useRef } from "react";
import { useIntersectionObserver, getTargetElement } from "./intersection-observer";

var isFunction = function (value) {
  return typeof value === "function";
};

export var LazyLoad = function (_a) {
  var children = _a.children,
      onVisible = _a.onVisible,
      container = _a.container,
      margin = _a.margin,
      threshold = _a.threshold;
  var ChildRef = useRef(null);

  var _b = useIntersectionObserver(),
      observerEntry = _b[0],
      listen = _b[1];

  useEffect(function () {
    isFunction(onVisible) && (onVisible === null || onVisible === void 0 ? void 0 : onVisible(observerEntry === null || observerEntry === void 0 ? void 0 : observerEntry.isIntersecting));
  }, [observerEntry]);
  useEffect(function () {
    if ((children === null || children === void 0 ? void 0 : children.length) > 1) {
      console.warn("LazyLoad children should be one.");
    }

    listen({
      rootMargin: margin,
      root: getTargetElement(container),
      threshold: threshold,
      element: getTargetElement(ChildRef)
    });
  }, []);
  return React.createElement("div", {
    ref: ChildRef
  }, children);
};